import type {I18nProvider} from "@refinedev/core"
import i18n from "../../i18n"
import {isAdminLanguage, saveAdminLanguage} from "../../utils/language"

export const i18nProvider: I18nProvider = {
    translate: (key, options, defaultMessage) => String(i18n.t(key, {
        ...options,
        defaultValue: defaultMessage || key
    })),
    changeLocale: async (locale) => {
        const language = isAdminLanguage(locale) ? locale : "ru"
        saveAdminLanguage(language)
        await i18n.changeLanguage(language)
    },
    getLocale: () => i18n.resolvedLanguage || i18n.language || "ru"
}
